// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zzLz","type":"styles_type__1Jg3N","choices":"styles_choices__2Z_D1"};